import { queryOptions } from '@tanstack/react-query';
import { api, PaginationResponse } from '@/api';
import type { Bid, BidDetails } from '@/features/bids/types';
import type { Document } from '@/features/documents/types';

export const bidsQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: ['bids', workspaceId],
    queryFn: async () =>
      (
        await api.get<PaginationResponse<Bid>>('v1/bids', {
          params: {
            tenderId: workspaceId,
            page: 1,
            pageSize: 1000,
            orderBy: 'CreatedAt',
            orderDirection: 'desc',
          },
        })
      ).data,
  });

export const bidDetailsQuery = (bidId: string) =>
  queryOptions({
    queryKey: ['bidDetails', bidId],
    queryFn: async () => (await api.get<BidDetails>(`v1/bids/${bidId}`)).data,
  });

export const TENDER_BID_DOCUMENTS_QUERY_KEY = 'tenderBidDocuments' as const;

export const tenderBidDocumentsQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: [TENDER_BID_DOCUMENTS_QUERY_KEY, workspaceId],
    queryFn: async () =>
      (
        await api.get<{
          documents: (Document & { bidId: string })[];
          indexing: {
            isIndexed: boolean;
            progress: number;
            lastProgressAt: string | null;
            isStalled: boolean;
            tenderPackage: { indexedPercentage: number; isIndexed: boolean } | null;
            bids: { bidId: string; indexedPercentage: number; isIndexed: boolean }[];
          };
        }>('v1/bids/documents', { params: { tenderId: workspaceId } })
      ).data,
    refetchInterval: (query) =>
      query.state.data && !query.state.data.indexing.isIndexed ? 8000 : false,
  });
